<script lang="ts">import ToggleField from "$components/form/ToggleField.svelte";
export let data = [];
export let fields = [];
export let createAction = undefined;
let search = '';
// reactive filtered list
$: filteredData = data.filter(v => v.name?.toLowerCase().includes(search.toLowerCase()));
</script>

<div class="w-full">
    <div class="flex flex-col flex-wrap gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="input max-w-xs">
            <span class="icon-[tabler--search] text-base-content/80 my-auto me-3 size-5 shrink-0"></span>
            <input type="search" class="grow" placeholder="Zoeken" id="leadingIconDefault" bind:value={search}/>
        </div>
        {#if createAction}<a class="btn btn-success" href="{createAction}">Toevoegen</a>{/if}
    </div>

    <div class="mt-8 overflow-x-auto">
        <table class="table">
            <thead>
                <tr>
                    <th>Naam</th>
                    {#each fields as field}
                        <th class="{field.hidden ? 'hidden ' : ''}md:table-cell">{field.value}</th>
                    {/each}
                    {#if filteredData[0]?.updateAction || filteredData[0]?.deleteAction}
                        <th>Acties</th>
                    {/if}
                </tr>
            </thead>
            <tbody>
                {#each filteredData as item}
                    <tr>
                        <td>{item.name}</td>
                        {#each fields as field}
                            <td class="{field.hidden ? 'hidden ' : ''}md:table-cell">
                                {#if field.type && field.type === 'boolean'}
                                    {#if item[field.key] === 1}
                                        <span class="icon-[tabler--check] size-5"></span>
                                    {:else}
                                        <span class="icon-[tabler--x] size-5"></span>
                                    {/if}
                                {:else if field.type && field.type === 'toggle'}
                                    <ToggleField {...item[field.key]}/>
                                {:else}
                                    {item[field.key]}
                                {/if}
                            </td>
                        {/each}
                        {#if item.viewAction || item.updateAction || item.deleteAction}
                            <td class="flex justify-start items-center">
                                {#if item.viewAction}
                                    <a href="{item.viewAction}" class="btn btn-circle btn-text btn-sm text-black dark:text-white" aria-label="Action button"><span class="icon-[tabler--eye] size-5"></span></a>
                                {/if}
                                {#if item.updateAction}
                                    <a href="{item.updateAction}" class="btn btn-circle btn-text btn-sm text-black dark:text-white" aria-label="Action button"><span class="icon-[tabler--pencil] size-5"></span></a>
                                {/if}
                                {#if item.deleteAction}
                                    <form method="post" action="{item.deleteAction.path}" on:submit={() => confirm('Weet je zeker dat je dit item wilt verwijderen?')}>
                                        <input type="hidden" name="_token" value="{item.deleteAction.csrf}">
                                        <button aria-label="item verwijderen" class="btn btn-circle btn-text btn-sm text-black dark:text-white"><span class="icon-[tabler--trash] size-5"></span></button>
                                    </form>
                                {/if}
                            </td>
                        {/if}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>
